import { IS_PRODUCTION } from "@marble/core/utils/environment";

/**
 * Insurance payers (Molina, Metroplus, Healthfirst, Fidelis) refer students
 * through a school created for each of them. Maps those school ids to the
 * payer ids used when creating the referred student's insurance info.
 */
export const SCHOOL_ID_TO_INSURANCE_PAYER_ID_MAP = IS_PRODUCTION
  ? {
      // Metroplus
      2327: 167,
      // Molina
      2438: 233,
      // Healthfirst
      2780: 107,
      // Fidelis NY
      15411: 434,
    }
  : {
      // Metroplus
      1922: 454,
      // Molina
      1923: 462,
      // Healthfirst
      1924: 274,
      // Fidelis NY
      56037: 196,
    };

export const INSURANCE_PAYER_SCHOOL_IDS = Object.keys(
  SCHOOL_ID_TO_INSURANCE_PAYER_ID_MAP,
).map(Number);
